// extracted by mini-css-extract-plugin
export default {"box":"style_box__MDIlk","countdown":"style_countdown__JEULC","value":"style_value__KiLii","valueAfter":"style_valueAfter__sZEWP"};